import React from "react";
import { T } from "Components";

import DashboardCard from "./DashboardCard";
import useStatistics from "../../Infrastructure/useStatistics";
import { FormatNumber } from "../../Infrastructure/format";

/**
 * Üye Tankları — birliğin üyelerine ait tank tipindeki araçların toplamı
 * (Member.MemberVehicle, VehicleType = "Tank").
 *
 * GET /Statistics/MemberTanks → { Rows, TotalCount, TotalTonnage }. Birlik
 * sunucuda çalışılan şirketten alınır; admin Birlik Özeti'nde istek
 * StatisticsEndpointContext ile /admin/TobOverview/CompanyMemberTanks'e
 * (seçili birlikle) yönlendirilir.
 *
 * Onay kararı (S1): tek birlik görünümünde yalnız toplam adet + tonaj gösterilir,
 * üye satırı yok. Toplamlar sunucuda kırpılmamış tüm satırlardan hesaplandığı
 * için satır sayısı en aza indirilir (take=1). Renkler yalnız tema token'larından.
 */

const MEMBER_TANKS_URL = "/Statistics/MemberTanks";

/** Satırlar kullanılmıyor; toplamlar take'ten bağımsız. */
const PARAMS = { take: 1 };

const EMPTY_LIST = { Rows: [], TotalCount: 0, TotalTonnage: 0 };

/** Tonaj: tam sayıysa ondalıksız, değilse 1 ondalık. */
const tonnageText = (value) => {
  const amount = Number(value) || 0;
  return FormatNumber(amount, Number.isInteger(amount) ? 0 : 1);
};

const MemberTanks = () => {
  const { data, loading, error } = useStatistics(MEMBER_TANKS_URL, EMPTY_LIST, PARAMS);

  const source = data && typeof data === "object" ? data : EMPTY_LIST;
  const totalCount = Number(source.TotalCount) || 0;
  const totalTonnage = Number(source.TotalTonnage) || 0;

  return (
    <DashboardCard
      className="fdash__membertanks"
      title={T.Main("dashboard.statistics.membertanks.title")}
      loading={loading}
      error={error}
      empty={totalCount === 0}
      emptyText={T.Main("dashboard.statistics.membertanks.empty")}
    >
      <div className="fdash__membertanks__stats" style={styles.stats}>
        <div style={styles.stat}>
          <span style={styles.label}>{T.Main("dashboard.statistics.membertanks.tankcount")}</span>
          <span style={styles.value}>{FormatNumber(totalCount)}</span>
        </div>

        <div style={{ ...styles.stat, ...styles.statDivider }}>
          <span style={styles.label}>{T.Main("dashboard.statistics.membertanks.totaltonnage")}</span>
          <span style={styles.value}>
            {tonnageText(totalTonnage)}
            <span style={styles.unit}>{` ${T.Main("dashboard.statistics.membertanks.ton")}`}</span>
          </span>
        </div>
      </div>
    </DashboardCard>
  );
};

// Satır içi düzen — modül bundle'ı CSS taşımıyor ve AdminUI scss'e dokunulmuyor.
// Yalnız token kullanılır; sabit renk yok.
const styles = {
  stats: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    fontVariantNumeric: "tabular-nums",
  },
  stat: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    minWidth: 0,
  },
  statDivider: {
    borderLeft: "1px solid var(--border)",
    paddingLeft: 14,
  },
  label: {
    fontSize: 11.5,
    fontWeight: 600,
    color: "var(--text-3)",
  },
  value: {
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: "-.02em",
    color: "var(--text)",
  },
  unit: {
    fontSize: 13,
    fontWeight: 600,
    color: "var(--text-2)",
  },
};

export default MemberTanks;
